import * as React from "react";
import Box from "@mui/material/Box";
import Header from "../components/HeaderMenu";
import ShadowAccountsDashboardComponent from "../components/ShadowAccountsDashboardComponent";
import { Footer } from "../components/FooterComponent";
import { globalStyles } from "../styles/global";
import usePageTracking from "../hooks/usePageTracking";

function ShadowAccountsDashboard() {
  usePageTracking();

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "black",
          color: "#fff",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "100%",
            gridTemplateRows: "auto",
            gridTemplateAreas: `"header"
                                "main"
                                "footer"`,
          }}
        >
          <Header />
          <Box sx={globalStyles.body}>
            <ShadowAccountsDashboardComponent />
          </Box>
          <Box sx={globalStyles.footer}>
            <Footer />
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default ShadowAccountsDashboard;
